export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

interface DemoItem {
    key: string
    label: string
    type: 'image' | 'video'
    src: string
    poster?: string
    name: string
}

const imageSrc = 'https://images.unsplash.com/photo-1495567720989-cebdbdd97913?auto=format&fit=crop&w=640&q=80';
const videoPoster = 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=640&q=80';
const videoSrc = 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4';

function withDemoKey(url: string, key: string) {
    const separator = url.includes('?') ? '&' : '?';

    return `${url}${separator}lazy-demo=${encodeURIComponent(key)}`;
}

function createLazyItems(): DemoItem[] {
    return Array.from({length: 16}, (_, index) => {
        const itemNo = index + 1;

        if (index % 2 === 0) {
            return {
                key: `image-${index}`,
                label: `图片 ${itemNo}`,
                type: 'image',
                src: withDemoKey(imageSrc, `image-${index}`),
                name: `图片 ${itemNo}.png`,
            };
        }

        return {
            key: `video-${index}`,
            label: `视频 ${itemNo}`,
            type: 'video',
            src: withDemoKey(videoSrc, `video-${index}`),
            poster: withDemoKey(videoPoster, `video-poster-${index}`),
            name: `视频 ${itemNo}.mp4`,
        };
    });
}

export default class extends Component {
    static template = template;

    static defaults() {
        return {
            eagerItems: [
                {
                    key: 'image-visible',
                    label: '首屏图片',
                    type: 'image',
                    src: withDemoKey(imageSrc, 'image-visible'),
                    name: '首屏图片.png',
                },
                {
                    key: 'video-visible',
                    label: '首屏视频',
                    type: 'video',
                    src: withDemoKey(videoSrc, 'video-visible'),
                    poster: withDemoKey(videoPoster, 'video-poster-visible'),
                    name: '首屏视频.mp4',
                },
            ] as DemoItem[],
            lazyItems: createLazyItems(),
        };
    }
}